
import { Component, ElementRef, TemplateRef, Input, ViewChild, OnInit, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { qmsService } from '../qms/qms.service';
import { forkJoin, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EditorComponent } from '../editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-more-activity-report-details',
  templateUrl: './more-activity-report-details.component.html',
  styleUrls: ['./more-activity-report-details.component.scss']
})
export class MoreActivityReportDetailsComponent implements OnInit, OnChanges {

  isProcessing: boolean = false;
  showTables: boolean = false;
  refreshbreadcrumb: boolean = true;
  PageName: any;
  searchValue: any;
  pagedItems: any[];
  error = '';
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  dropDownForModules: any;
  popupTitle: any;
  groupValueDropdown: any = [];
  groupdataList: any = [];
  stageAndStatus: any = [];
  allTasksList: any = [];
  dropDownForDateRange: any = [];
  dropDownForInterval: any = [];
  stageValueDropdown: any = [];
  dateRangeValueDropdown: any = [];
  statusValueDropdown: any = [];
  statusValueDropdown1: any = [];
  intervalValueDropdown: any = [];
  selectedStatusValue: any = null;
  selectedDateRangeValue: any = null;
  selectedIntervalValue: any = null;
  selectedStageValue: any = null;
  selectedTaskTypeValue: any = null;
  selectedDocumentTypeVal: any;
  selectedGroupValue: any = null;
  fromDate: any;
  toDate: any;
  showSpecificInterval: boolean = false;
  dateCustomClasses: DatepickerDateCustomClasses[];
  chartOptionsForStages: any;
  chartOptionsForStatus: any;
  getOneQmsUsersVwDetailsForManagerselection: any;
  activityId: any;
  selectedDateUpdateRangeValue: any = null;
  showNoRecordFoundPerformance: boolean = false;
  showNoRecordFoundPendingAction: boolean = false;
  showNoRecordFoundExtension: boolean = false;
  showNoRecordFoundEffectiveness: boolean = false;
  showNoRecordFoundAction: boolean = false;
  showNoRecordFoundOverdue: boolean = false;
  showNoRecordFoundMileStone: boolean = false;
  showNoRecordFoundDeleted: boolean = false;
  showNoRecordFoundObsoleted: boolean = false;
  isDropdownDisabled: boolean = true;
  departmentSearchText: string = '';
  whereValsForExcel: any;
  changeTypeDropdown: any = [];
  selectedOverDue: any = null;
  dropDownForOverDue: any = [];
  overDueDropDown: any = [];
  //effectiveness
  selectedUpdateDate: any = null;
  dropDownForUpdateDate: any = [];
  updateDateDropDown: any = [];
  //action
  selectedActionDate: any = null;
  dropDownForActionDate: any = [];
  actionDateDropDown: any = [];
  //Extension
  selectedExtensionDate: any = null;
  dropDownForExtensionDate: any = [];
  extensionDateDropDown: any = [];

  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};

  pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  pagedItems4: any[];
  pagedItems5: any[];
  showMore: boolean = false;

  toggleMore() {
    this.showMore = !this.showMore;
  }

  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  selectedDesignationValue: any = null;
  selectedDepartmentValue: any = null;

  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;
  constructor(public dialog: MatDialog, public appService: AppService, public route: ActivatedRoute, public message: messageService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public service: messageService, public qmsservice: qmsService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute, public paginationService: PaginationService) {
    const now = new Date();
    this.appService.isProcessingRep = false;
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  onStageValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {

        this.selectedStatusValue = null;
        for (let i = 0; i < this.stageAndStatus.length; i++) {
          if (this.stageAndStatus[i].stageName == item.valueExp) {
            this.statusValueDropdown = [];
            const statusArray = this.stageAndStatus[i].listOfStatus.split(',').map((status: string) => status.trim());
            this.statusValueDropdown = this.statusValueDropdown.concat(statusArray.filter((status: any) => !this.statusValueDropdown.includes(status)));
          }
          if (i == this.stageAndStatus.length - 1) {
            this.statusValueDropdown.sort((a: any, b: any) => a.localeCompare(b));
            console.log(this.statusValueDropdown)
            this.statusValueDropdown1 = [];
            for (const status of this.statusValueDropdown) {
              this.statusValueDropdown1 = this.statusValueDropdown1.concat({
                valueExp: status,
                displayExp: status
              });
            }
          }
        }
      } else {
        this.selectedStatusValue = null;
      }
    }
  }

  selectBoxeForGroupValue() {
    this.isProcessing = true;
    this.groupValueDropdown = [];
    for (const group of this.groupdataList) {
      this.groupValueDropdown.push({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
    this.isProcessing = false;
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    for (const item of this.dropDownForDateRange) {
      this.dateRangeValueDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    for (const item of this.dropDownForInterval) {
      this.intervalValueDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  selectBoxForOverDue() {
    this.overDueDropDown = [];
    this.overDueDropDown = this.dropDownForOverDue?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []

  }
  selectBoxForUpdateDate() {
    this.updateDateDropDown = [];
    this.updateDateDropDown = this.dropDownForUpdateDate?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []

  }

  selectBoxForActionDate() {
    this.actionDateDropDown = [];
    this.actionDateDropDown = this.dropDownForActionDate?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []

  }

  selectBoxForExtensionDate() {
    this.extensionDateDropDown = [];
    this.extensionDateDropDown = this.dropDownForExtensionDate?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []

  }

  selectBoxeForchangeType() {
    this.changeTypeDropdown = [];
    for (const item of this.dropDownForChangeType) {
      this.changeTypeDropdown.push({
        valueExp: item.type,
        displayExp: item.type
      });
    }
  }
  selectBoxeForStageValue() {
    this.stageValueDropdown = [];
    for (const item of this.stageAndStatus) {
      this.stageValueDropdown.push({
        valueExp: item.stageName,
        displayExp: item.stageName
      });
    }
    this.stageAndStatus.forEach((item: { listOfStatus: string; }) => {
      const statusArray = item.listOfStatus.split(',').map(status => status.trim());
      this.statusValueDropdown = this.statusValueDropdown.concat(statusArray.filter(status => !this.statusValueDropdown.includes(status)));
    });
    this.statusValueDropdown1 = [];
    for (const item of this.statusValueDropdown) {
      this.statusValueDropdown1.push({
        valueExp: item,
        displayExp: item
      });
    }
    console.log(this.statusValueDropdown1, "===")
  }
  specificIntervalVal: boolean = false;
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      this.selectedDateRangeValue = 'CREATED';
      this.fromDate = null;
      this.toDate = null;
      this.selectedIntervalValue = 'MONTH';
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  stageList: any = [];
  statusList: any = [];
  PerformansList: any = [];

  resetFunction() {
    this.specificIntervalVal = false;
    this.fromDate = null;
    this.toDate = null;
    this.selectedOverDue = null;
    this.selectedStageValue = null;
    this.selectedTaskTypeValue = null;
    this.getSelectedTaskNo = '';
    this.selectedStatusValue = null;
    this.dropDownForUpdateDate = [];
    this.dropDownForExtensionDate = [];
    this.activityId = null;
    this.dropDownForActionDate = [];
    this.showTables = false;
    this.selectedExtensionDate = null;
    this.selectedUpdateDate = null;
    this.selectedActionDate = null;
    this.getSelectedTaskId = [];
    [this.oneQmsUsersFieldData.managerId, this.oneQmsUsersFieldData.managerName] = [null, ''];

  }
  resetFunction1() {
    this.specificIntervalVal = false;
    this.fromDate = null;
    this.toDate = null;
    this.selectedOverDue = null;
    this.selectedStageValue = null;
    this.selectedTaskTypeValue = null;
    this.getSelectedTaskNo = '';
    this.selectedStatusValue = null;
    this.dropDownForUpdateDate = [];
    this.dropDownForExtensionDate = [];
    this.activityId = null;
    this.dropDownForActionDate = [];
    this.showTables = false;
    this.selectedExtensionDate = null;
    this.selectedUpdateDate = null;
    this.selectedActionDate = null;
    [this.oneQmsUsersFieldData.managerId, this.oneQmsUsersFieldData.managerName] = [null, ''];
  }

  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportPerformansDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportPerformansDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.pendingActionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.pendingActionList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter2(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems2 = this.extensionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems2 = this.extensionTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter3(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems3 = this.ecTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems3 = this.ecTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter4(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems4 = this.actionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems4 = this.actionTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter5(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems5 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems5 = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter6(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj;
    } else {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (typeof columnValue === 'string') {
          console.log("columnValue1=", columnValue);
          return columnValue.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }
  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    console.log("prim", data);
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }


  genReport() {
    this.whereValsForExcel = "";
    console.log("this.qmsservice.reportFor==", this.qmsservice.reportFor);
    if (this.qmsservice.reportFor == 'Performance') {
      if (this.qmsservice.moduleName == "AU") {
        this.columnList = this.qmsservice.moduleName + ` ID,Dept Name, ${this.qmsservice.moduleName} Type,Additional Details,Requested At,Business Area,Status,Stage Name,Planner,Lead Auditor,Plan Approver,Reviewers,Approvers,Closure Reviewers,Closure Approvers,Peer Reviewers`;
      } else if (this.qmsservice.moduleName == 'CR' && this.qmsservice.moduleName == 'CAPA' && this.qmsservice.moduleName == 'DV') {
        this.columnList = this.qmsservice.moduleName + ` ID,Dept Name, ${this.qmsservice.moduleName} Type,Additional Details,Requested At,Business Area,Status,Stage Name,Initiator,Owner,QA User,Reviewers,Approvers,Closure Reviewers,Closure Approvers`;
      } else {
        this.columnList = this.qmsservice.moduleName + ` ID,Dept Name, ${this.qmsservice.moduleName} Type,Additional Details,Requested At,Business Area,Status,Stage Name,Initiator,Owner,QA User,Investigator,Reviewers,Approvers,Closure Reviewers,Closure Approvers`;
      }
      const validations = [
        { condition: (!this.selectedGroupValue), id: 'groupNameAlert' },
        { condition: (this.specificIntervalVal && !this.fromDate), id: 'fromDateAlert' },
        { condition: (this.specificIntervalVal && !this.toDate), id: 'toDateAlert' },
      ]
      const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
      if (invalidIds.length > 0) {
        this.fieldValidation(invalidIds);
      } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        if (this.activityId) {
          this.whereValsForExcel = " where TASK_ID='" + this.activityId + "'";
        } else {
          this.whereValsForExcel = "";
        }
        console.log("this.selectedStatusValue=" + this.selectedStatusValue)
        const data = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          no: this.activityId
        }


        this.isProcessing = true;
        forkJoin([
          this.appService.getTaskPerformersRepVwReportVal(data)]).subscribe(([PerformansList]) => {
            this.tableReportPerformansDataList = PerformansList;
            this.showTables = true;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportPerformansDataList.length;
            this.totalPages = Math.ceil(this.tableReportPerformansDataList.length / this.itemsPerPage);
            this.setPage1(1, 0);
            this.showNoRecordFoundPerformance = this.tableReportPerformansDataList.length === 0;
            this.isProcessing = false;
          });
      }
    } else if (this.qmsservice.reportFor == 'Activity Vs User') {
      console.log("this.qmsservice.reportFor==", this.qmsservice.reportFor);
      this.columnList =
        this.qmsservice.moduleName +
        " ID,Task Name,Status,Other Details,Task Owner User Name,Requester User Name,Action Requested On,Pending With User,Due On,Sub Task Name";

      this.whereValsForExcel = this.oneQmsUsersFieldData.managerId
        ? " WHERE INSTR(','||PENDING_WITH_USERS||',',','||" +
        this.oneQmsUsersFieldData.managerId +
        "||',') <> 0 AND MODULE_CODE ='" +
        this.qmsservice.moduleName +
        "' AND GROUP_ID =" +
        this.selectedGroupValue
        : " WHERE MODULE_CODE ='" +
        this.qmsservice.moduleName +
        "' AND GROUP_ID =" +
        this.selectedGroupValue;
      if (this.selectedGroupValue) {
        console.log("this.qmsservice.reportFor==", this.qmsservice.reportFor);
        const data = {

          groupId: this.selectedGroupValue ?? null,
          module: this.qmsservice.moduleName,
          stageName: this.selectedStageValue ?? null,
          status: this.selectedStatusValue ?? null,
          no: this.activityId,
          wherVal: this.oneQmsUsersFieldData.managerId ?? null,
        };
        this.isProcessing = true;
        forkJoin([
          this.appService.getPendingTaskForUSer(data)
        ]).subscribe(([pendingActionList]) => {
          this.pendingActionList = pendingActionList;
          this.showTables = true;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.pendingActionList.length;
          this.totalPages = Math.ceil(this.pendingActionList.length / this.itemsPerPage);
          this.setPage2(1, 0);
          this.showNoRecordFoundPendingAction =
            this.pendingActionList.length === 0;
          this.isProcessing = false;
        });
        return;
      }
      const field = document.getElementById('groupNameAlert') as HTMLInputElement;
      if (field) {
        field.style.color = 'red';
      }
    } else if (this.qmsservice.reportFor == 'Product Report') {
      this.whereValsForExcel = " WHERE ORG_ID =" + this.message.getOrgId() + " AND MODULE ='" + this.qmsservice.moduleName + "'";
      this.whereValsForExcel += " AND GROUP_ID=" + this.selectedGroupValue;
      this.getcallMethodProduct();

    } else if (this.qmsservice.reportFor == 'Pending Actions') {

      this.columnList =
        this.qmsservice.moduleName +
        "ID,Task Name,Current Status,Sub Task Current Status,Task Or Subtask Previous Status,Other Details,Task Owner User Name,Requester User Name,Operation,Action Requested On,Pending With User,Pending With Users Role,Comments,Due On,Is Enabled,Sub Task Type,Sub Task Name";

      this.whereValsForExcel =
        " WHERE ORG_ID =" + this.message.getOrgId() +
        " AND INSTR(','||PENDING_WITH_USERS||',',','||" +
        this.oneQmsUsersFieldData.managerId +
        "||',') <> 0 AND IS_ENABLED = 'Y' AND MODULE_NAME ='" +
        this.qmsservice.moduleName +
        "' AND GROUP_ID =" +
        this.selectedGroupValue;

      if (this.selectedGroupValue) {

        if (this.oneQmsUsersFieldData.managerId) {

          const data = {

            groupId: this.selectedGroupValue ?? null,
            module: this.qmsservice.moduleName,
            stageName: this.selectedStageValue ?? null,
            status: this.selectedStatusValue ?? null,
            no: this.activityId,
            wherVal: this.oneQmsUsersFieldData.managerId
          };

          this.isProcessing = true;

          forkJoin([
            this.appService.getPendingActionRep(data)
          ]).subscribe(([pendingActionList]) => {

            this.pendingActionList = pendingActionList;
            this.showTables = true;

            this.calculateTotalPages =
              this.collectionSize / this.perPage;

            this.pager.totalPages = undefined;

            this.collectionSize = this.pendingActionList.length;

            this.totalPages = Math.ceil(
              this.pendingActionList.length / this.itemsPerPage
            );

            this.setPage2(1, 0);

            this.showNoRecordFoundPendingAction =
              this.pendingActionList.length === 0;

            this.isProcessing = false;

          });

          return;
        }

        try {

          const field = document.getElementById('userName') as HTMLInputElement;

          if (field) {
            field.style.color = 'red';
          }

        } catch (error) {

          console.error(error);

        }

        return;
      }

      const field = document.getElementById('groupNameAlert') as HTMLInputElement;

      if (field) {
        field.style.color = 'red';
      }
    } else if (this.qmsservice.reportFor == 'Overdue') {

      this.columnList =
        `${this.qmsservice.moduleName} ID,${this.qmsservice.moduleName} Description,Dept Code,Requested At,Business Area,Expected Closure Date,Owner Fullname,QA User,Started On,Completed On,Status,Stage Name,Effectiveness Check Required`;

      if (this.selectedGroupValue) {

        if (this.selectedOverDue) {

          let wherVal;
          let columnVal;

          console.log(this.selectedOverDue);

          console.log(this.selectedOverDue);
          if (this.selectedOverDue == "DUE IN 7") {
            wherVal = '7';
            columnVal = "Due";
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON > SYSDATE AND TASKS.EXPCETED_CLOSURE_ON <= (SYSDATE+" + 7 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
          } else if (this.selectedOverDue == "DUE IN 14") {
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON > SYSDATE AND TASKS.EXPCETED_CLOSURE_ON <= (SYSDATE+" + 14 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
            wherVal = '14';
            columnVal = "Due";
          } else if (this.selectedOverDue == "DUE IN 30") {
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON > SYSDATE AND TASKS.EXPCETED_CLOSURE_ON <= (SYSDATE+" + 30 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
            wherVal = '30';
            columnVal = "Due";
          } else if (this.selectedOverDue == "DUE IN 90") {
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON > SYSDATE AND TASKS.EXPCETED_CLOSURE_ON <= (SYSDATE+" + 90 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
            wherVal = '90';
            columnVal = "Due";
          } else if (this.selectedOverDue == "OVER DUE IN 7") {
            wherVal = '7';
            columnVal = "Over";
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON < SYSDATE AND TASKS.EXPCETED_CLOSURE_ON >= (SYSDATE-" + 7 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
          } else if (this.selectedOverDue == "OVER DUE IN 14") {
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON < SYSDATE AND TASKS.EXPCETED_CLOSURE_ON >= (SYSDATE-" + 14 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
            wherVal = '14';
            columnVal = "Over";
          } else if (this.selectedOverDue == "OVER DUE IN 30") {
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON < SYSDATE AND TASKS.EXPCETED_CLOSURE_ON >= (SYSDATE-" + 30 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
            wherVal = '30';
            columnVal = "Over";
          } else if (this.selectedOverDue == "OVER DUE IN 90") {
            this.whereValsForExcel = " TASKS,QMS_TASK_EXTENSIONS EXTENSIONS WHERE TASKS.ORG_ID =" + this.message.getOrgId() + " AND TASKS.MODULE = '" + this.qmsservice.moduleName + "' AND TASKS.GROUP_ID= '" + this.selectedGroupValue + "' AND TASKS.STATUS NOT IN ('Deleted','Obsoleted','Closed') AND TASKS.EXPCETED_CLOSURE_ON < SYSDATE AND TASKS.EXPCETED_CLOSURE_ON >= (SYSDATE-" + 90 + ") AND EXTENSIONS.ORG_ID(+) = TASKS.ORG_ID AND EXTENSIONS.REF_NO(+) = TASKS.TASK_NO AND EXTENSIONS.STATUS(+) <> 'Approved'";
            wherVal = '90';
            columnVal = "Over";
          }


          const data = {
            groupId: this.selectedGroupValue ?? null,
            module: this.qmsservice.moduleName,
            dateRangeAt: this.selectedDateRangeValue ?? null,
            fromDate: this.fromDate
              ? this.appService.dateZoneConvertion(new Date(this.fromDate))
              : null,
            toDate: this.toDate
              ? this.appService.dateZoneConvertion(new Date(this.toDate))
              : null,
            intervals: this.selectedIntervalValue ?? null,
            stageName: this.selectedStageValue ?? null,
            status: this.selectedStatusValue ?? null,
            columnVal: columnVal,
            wherVal: wherVal
          };



          this.isProcessing = true;

          forkJoin([
            this.appService.getOverDueRep(data)
          ]).subscribe(([overdueList]) => {

            this.tableReportDataList = overdueList;
            this.showTables = true;

            this.calculateTotalPages =
              this.collectionSize / this.perPage;

            this.pager.totalPages = undefined;

            this.collectionSize = this.tableReportDataList.length;

            this.totalPages = Math.ceil(
              this.tableReportDataList.length / this.itemsPerPage
            );

            this.setPage6(1, 0);

            this.showNoRecordFoundOverdue =
              this.tableReportDataList.length === 0;

            this.isProcessing = false;

          });

          return;
        }

        try {

          const field = document.getElementById('overDue') as HTMLInputElement;

          if (field) {
            field.style.color = 'red';
          }

        } catch (error) {

          console.error(error);

        }

        return;
      }

      const field = document.getElementById('groupNameAlert') as HTMLInputElement;

      if (field) {
        field.style.color = 'red';
      }
    } else if (this.qmsservice.reportFor == 'Extension') {
      this.columnList = `${this.qmsservice.moduleName} ID,Extension ID,Current Due Date,Extension Required Till,Justification,Status,Review Requested On,Reviewer,Reviewed On,Review Comments,Approve Requested On,Approver,Approved On,Approver Comments,Created By User,Extension Type,Action Details`;
      if (!this.selectedGroupValue) {
        const field = document.getElementById('groupNameAlert') as HTMLInputElement;
        if (field) {
          field.style.color = 'red';
        }
      } else if (!this.selectedExtensionDate) {
        try {
          const field = document.getElementById('dateRange') as HTMLInputElement;
          if (field) {
            field.style.color = 'red';
          }
        } catch (error) {
          console.error(error);
        }
      } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        console.log(this.selectedUpdateDate, +"====" + this.selectedUpdateDate);
        let data = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedExtensionDate ? this.selectedExtensionDate : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          no: this.activityId,
        }


        this.isProcessing = true;
        forkJoin([
          this.appService.getExtensionsIntervalRep(data)]).subscribe(([extensionsIntervalRepList]) => {
            this.extensionTableReportDataList = extensionsIntervalRepList;
            this.showTables = true;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.extensionTableReportDataList.length;
            this.totalPages = Math.ceil(this.extensionTableReportDataList.length / this.itemsPerPage);
            this.setPage3(1, 0);
            this.showNoRecordFoundExtension = this.extensionTableReportDataList.length === 0;
            this.isProcessing = false;
          });
      }
    } else if (this.qmsservice.reportFor == 'Effectiveness Check') {
      this.columnList = `${this.qmsservice.moduleName} ID,EC ID,Due Date,Methodology,Criteria,Conclusion,Outcome,Closure Comments,Approval Requested On,Approval Comments,Approved On,Approver,QA Approval Requested On,QA Approved On,QA Approver,QA Approval Comments,Reminder Days Before Due Date,Created By User,Triggered From Execution Context ID,Check Required For,Status,Owner Name,Start Date`;

      if (!this.selectedGroupValue) {
        const field = document.getElementById('groupNameAlert') as HTMLInputElement;
        if (field) {
          field.style.color = 'red';
        }
      } else if (!this.selectedUpdateDate) {
        try {
          const field = document.getElementById('dateRange') as HTMLInputElement;
          if (field) {
            field.style.color = 'red';
          }
        } catch (error) {
          console.error(error);
        }
      } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        let data = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedUpdateDate ? this.selectedUpdateDate : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          no: this.activityId
        }


        this.isProcessing = true;
        forkJoin([
          this.appService.getEcIntervalRep(data)]).subscribe(([ecList]) => {
            this.ecTableReportDataList = ecList;
            this.showTables = true;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.ecTableReportDataList.length;
            this.totalPages = Math.ceil(this.ecTableReportDataList.length / this.itemsPerPage);
            this.setPage4(1, 0);
            this.showNoRecordFoundEffectiveness = this.ecTableReportDataList.length === 0;
            this.isProcessing = false;
          });
      }
    } else if (this.qmsservice.reportFor == 'Action') {
      this.columnList = `${this.qmsservice.moduleName} ID,SL NO,Action ID,Action Name,Action Description,Started On,Status,Target Date,Action At,Core Business Area,Assigned To,Assigned To Department,Comments,Action Performed,Review Requested On,Reviewer,Review Status,Review Comments,Review Completed On,Approval Requested On,Approver,Approval Status,Approval Comments,Approval Completed On,Defer Reviewer,Defer Approver,Created On,Created By User,Intervals`;
      if (!this.selectedGroupValue) {
        const field = document.getElementById('groupNameAlert') as HTMLInputElement;
        if (field) {
          field.style.color = 'red';
        }
      } else if (!this.selectedActionDate) {
        try {
          const field = document.getElementById('dateRange') as HTMLInputElement;
          if (field) {
            field.style.color = 'red';
          }
        } catch (error) {
          console.error(error);
        }
      } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        let data = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedActionDate ? this.selectedActionDate : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          no: this.activityId
        }
        this.isProcessing = true;
        forkJoin([
          this.appService.getActionIntervalRep(data)]).subscribe(([actionList]) => {
            this.actionTableReportDataList = actionList;
            this.showTables = true;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.actionTableReportDataList.length;
            this.totalPages = Math.ceil(this.actionTableReportDataList.length / this.itemsPerPage);
            this.setPage5(1, 0);
            this.showNoRecordFoundAction = this.actionTableReportDataList.length === 0;
            this.isProcessing = false;
          });
      }
    } else if (this.qmsservice.reportFor == 'Deleted') {

      this.columnList =
        `${this.qmsservice.moduleName} ID,${this.qmsservice.moduleName} Description,Department Code,Requested At,Business Area,Owner ,QA ,Started On,Completed On,Status,Stage Name,Effectiveness Check Required`;

      this.whereValsForExcel =
        " WHERE ORG_ID =" +
        this.message.getOrgId() +
        " AND MODULE ='" +
        this.qmsservice.moduleName +
        "' AND STATUS = 'Deleted'";

      this.whereValsForExcel +=
        " AND GROUP_ID=" + this.selectedGroupValue;

      if (this.selectedGroupValue) {

        const data = {
          groupId: this.selectedGroupValue ?? null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ?? null,
          fromDate: this.fromDate
            ? this.appService.dateZoneConvertion(new Date(this.fromDate))
            : null,
          toDate: this.toDate
            ? this.appService.dateZoneConvertion(new Date(this.toDate))
            : null,
          intervals: this.selectedIntervalValue ?? null,
          stageName: this.selectedStageValue ?? null,
          status: this.selectedStatusValue ?? null,
          no: this.activityId
        };



        this.isProcessing = true;

        forkJoin([
          this.appService.getDeletedActivityRepList(data)
        ]).subscribe(([deletedList]) => {

          this.tableReportDataList = deletedList;
          this.showTables = true;

          this.calculateTotalPages =
            this.collectionSize / this.perPage;

          this.pager.totalPages = undefined;

          this.collectionSize =
            this.tableReportDataList.length;

          this.totalPages = Math.ceil(
            this.tableReportDataList.length / this.itemsPerPage
          );

          this.setPage6(1, 0);

          this.showNoRecordFoundDeleted =
            this.tableReportDataList.length === 0;

          this.isProcessing = false;

        });

        return;
      }

      const field = document.getElementById('groupNameAlert') as HTMLInputElement;

      if (field) {
        field.style.color = 'red';
      }
    } else if (this.qmsservice.reportFor == 'Obsoleted') {

      this.columnList =
        `${this.qmsservice.moduleName} ID,${this.qmsservice.moduleName} Description,Department Code,Requested At,Business Area,Owner ,QA ,Started On,Completed On,Status,Stage Name,Effectiveness Check Required`;

      this.whereValsForExcel =
        " WHERE ORG_ID =" +
        this.message.getOrgId() +
        " AND MODULE ='" +
        this.qmsservice.moduleName +
        "' AND STATUS = 'Obsoleted'";

      this.whereValsForExcel +=
        " AND GROUP_ID=" + this.selectedGroupValue;

      if (this.selectedGroupValue) {

        const data = {
          groupId: this.selectedGroupValue ?? null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ?? null,
          fromDate: this.fromDate
            ? this.appService.dateZoneConvertion(new Date(this.fromDate))
            : null,
          toDate: this.toDate
            ? this.appService.dateZoneConvertion(new Date(this.toDate))
            : null,
          intervals: this.selectedIntervalValue ?? null,
          stageName: this.selectedStageValue ?? null,
          status: this.selectedStatusValue ?? null,
          no: this.activityId
        };



        this.isProcessing = true;

        forkJoin([
          this.appService.getObsoluteActivityRepList(data)
        ]).subscribe(([obsolutedList]) => {

          this.tableReportDataList = obsolutedList;
          this.showTables = true;

          this.calculateTotalPages =
            this.collectionSize / this.perPage;

          this.pager.totalPages = undefined;

          this.collectionSize =
            this.tableReportDataList.length;

          this.totalPages = Math.ceil(
            this.tableReportDataList.length / this.itemsPerPage
          );

          this.setPage6(1, 0);

          this.showNoRecordFoundObsoleted =
            this.tableReportDataList.length === 0;

          this.isProcessing = false;

        });

        return;
      }

      const field = document.getElementById('groupNameAlert') as HTMLInputElement;

      if (field) {
        field.style.color = 'red';
      }
    } else if (this.qmsservice.reportFor == 'Milestone') {
      this.columnList = `${this.qmsservice.moduleName}  ID, Status, ${this.qmsservice.moduleName}  Type, Created On, Review Requested On, Review Completed On, Approval Requested On, Approval Completed On, Closure Review Requested On, Closure Review Completed On, Closure Approval Requested On, Closure Approval Completed On, Started On, Completed On, Signoff Requested On, Signoff Completed On`;

      this.whereValsForExcel = " WHERE ORG_ID =" + this.message.getOrgId() + " AND MODULE ='" + this.qmsservice.moduleName + "'";
      if (this.selectedTaskTypeValue) {
        this.whereValsForExcel += " AND TASK_TYPE ='" + this.selectedTaskTypeValue + "'";
      }
      if (this.getSelectedTaskNo) {
        this.whereValsForExcel += " AND (TASK_NO='" + this.getSelectedTaskNo + "' OR PARENT_TASK_NO='" + this.getSelectedTaskNo + "')";
      }
      if (!this.selectedGroupValue) {
        const field = document.getElementById('groupNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        let data = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          taskType: this.selectedTaskTypeValue ? "'" + this.selectedTaskTypeValue + "'" : null,
          no: this.activityId,
          taskNo: this.getSelectedTaskNo
        }

        this.isProcessing = true;
        forkJoin([
          this.appService.getTaskMilestonesIntervalsRepVw(data)]).subscribe(([MilestonesIntervalsRepVw]) => {
            this.tableReportDataList = MilestonesIntervalsRepVw;
            this.showTables = true;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportDataList.length;
            this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
            this.setPage6(1, 0);
            this.showNoRecordFoundMileStone = this.tableReportDataList.length === 0;
            this.isProcessing = false;
          });
      }
    }
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportPerformansDataList.length, page, this.perPage, targetpage);
    if (this.tableReportPerformansDataList.length > 0) {
      this.pagedItems = this.tableReportPerformansDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }

  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.pendingActionList.length, page, this.perPage, targetpage);
    if (this.pendingActionList.length > 0) {
      this.pagedItems1 = this.pendingActionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  setPage3(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.extensionTableReportDataList.length, page, this.perPage, targetpage);
    if (this.extensionTableReportDataList.length > 0) {
      this.pagedItems2 = this.extensionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall3(value: number) {
    this.perPage = value;
    this.setPage3(this.pager.currentPage, 0);
  }
  setPage4(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.ecTableReportDataList.length, page, this.perPage, targetpage);
    if (this.ecTableReportDataList.length > 0) {
      this.pagedItems3 = this.ecTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall4(value: number) {
    this.perPage = value;
    this.setPage4(this.pager.currentPage, 0);
  }
  setPage5(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.actionTableReportDataList.length, page, this.perPage, targetpage);
    if (this.actionTableReportDataList.length > 0) {
      this.pagedItems4 = this.actionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall5(value: number) {
    this.perPage = value;
    this.setPage5(this.pager.currentPage, 0);
  }
  setPage6(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems5 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall6(value: number) {
    this.perPage = value;
    this.setPage6(this.pager.currentPage, 0);
  }


  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'pdf-select-all');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }
  @ViewChild('searchManager', { static: true }) searchManager: TemplateRef<any>;
  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;
  searchManagerConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  @ViewChild('searchTaskVW', { static: true }) searchTaskVW: TemplateRef<any>;
  visibleSearchTaskVwPopup: MatDialogRef<TemplateRef<any>>;
  searchTaskVWConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  selectBoxeForDesignationCode() {
    for (const item of this.dropDownForDesignationCode) {
      this.designationCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }
  selectBoxeForDepartmentCode() {
    for (const item of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDesignationValue = item.valueExp;
    }
  }
  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDepartmentValue = item.valueExp;
    }
  }

  getSelectedTaskId: any;
  getSelectedTaskNo: any;
  getSelectedUserId: any;
  getSelectedUserName: string;
  privvalue: any;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getOneQmsUsersVwDetailsTableData[this.privvalue].searchManagerChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
    this.privvalue = idx;
  }
  searchTaskVwChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getTaskDetailsObj1[this.privvalue].searchManagerChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedTaskId = listOfUsersVwDetails.taskId;
      this.getSelectedTaskNo = listOfUsersVwDetails.taskNo;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
    this.privvalue = idx;
  }
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByemailAddress: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  getTaskDetailsObj: any = [];
  getTaskDetailsObj1: any = [];
  popupDataTitle: PopupData = {
    title: ''
  };
  searchManagerFunction() {
    this.searchManagerChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupDataTitle.title = "Search User";
    this.visibleSearchManagerPopup = this.dialog.open(this.searchManager, this.searchManagerConfig);
  }
  searchTaskVwFunction() {
    this.popupDataTitle.title = "Select Task ID";
    this.isProcessing = true;
    this.appService.getQmsAllTasksVw(this.qmsservice.moduleName).subscribe((data: any) => {
      this.getTaskDetailsObj = data;
      this.getTaskDetailsObj1 = data;
      this.isProcessing = false;
    })
    this.visibleSearchTaskVwPopup = this.dialog.open(this.searchTaskVW, this.searchTaskVWConfig);
  }
  operationFlag: any
  oneQmsUsersFieldData: any = {};
  addManagerNameFunction() {
    this.oneQmsUsersFieldData.managerId = this.getSelectedUserId;
    this.oneQmsUsersFieldData.managerName = this.getSelectedUserName;
    this.onNgModelChange(this.oneQmsUsersFieldData.managerName, 'userName');
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchManagerPopup.close();
  }
  addTaskVwGridDataFunction() {
    this.visibleSearchTaskVwPopup.close();
  }
  cancelAllTaskVwFunction() {
    this.getSelectedTaskId = null;
    this.getSelectedTaskNo = '';
    this.visibleSearchTaskVwPopup.close();
  }
  cancelSearchManagerFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchManagerPopup.close();
  }

  searchManagerGridDataFunction() {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode ? this.searchByDesignationCode : null;
    this.departmentCodeValue = this.searchByDepartmentCode ? this.searchByDepartmentCode : null;
    this.searchByUserName =
      this.searchByUserName?.toUpperCase() ?? '';
    this.searchOneQmsUserVwDetails = {
      userName: this.searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByemailAddress,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchManagerGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  searchGridFunction() {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode ? this.searchByDesignationCode : null;
    this.departmentCodeValue = this.searchByDepartmentCode ? this.searchByDepartmentCode : null;
    this.searchOneQmsUserVwDetails = {

      userName: this.searchByUserName.toUpperCase(),
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue
    };
  }
  //view popoup
  titleName = '';
  tableReportDataList: any = [];
  tableReportPerformansDataList: any = [];
  extensionTableReportDataList: any = [];
  pendingActionList: any = [];
  ecTableReportDataList: any = [];
  actionTableReportDataList: any = [];
  tableReportDeletedDataList: any = [];
  tableReportObsolutedDataList: any = [];
  ecList: any = [];
  extensionList: any = [];
  actionList: any = [];
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  //Excell & PDF
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 1,
  };
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }

  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};

  isSaveReport: boolean = false;

  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  onlyDateColumn: any;
  generateReport(value: any) {
    this.onlyDateColumn = "";
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let data2;
      let datas;
      if (this.qmsservice.reportFor == 'Performance') {
        if (this.qmsservice.moduleName == "AU") {
          tname = "QMS_ALL_TASK_PERFORMERS_REP_VW";
          colList = "TASK_ID,DEPT_NAME,TASK_TYPE,SHORT_DESCRIPTION,REQUESTED_AT,CORE_BUSINESS_AREA_NAME,STATUS,STAGE_NAME,INITIATOR,OWNER,QA_ACCEPTOR,REVIEWRS,APPROVERS,CLOSURE_REVIEWRS,CLOSURE_APPROVERS,PEER_REVIEWERS";
          fieldList = this.qmsservice.moduleName + ` ID,Dept Name, ${this.qmsservice.moduleName} Type,Additional Details,Requested At,Business Area,Status,Stage Name,Planner,Lead Auditor,Plan Approver,Reviewers,Approvers,Closure Reviewers,Closure Approvers,Peer Reviewers`;
          data2 = {

            groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
            module: this.qmsservice.moduleName,
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: this.selectedStageValue ? this.selectedStageValue : null,
            status: this.selectedStatusValue ? this.selectedStatusValue : null,
            no: this.activityId,
            wherVal: this.whereValsForExcel,
            reModule: "qms1"
          }
        } else if (this.qmsservice.moduleName == 'CR' || this.qmsservice.moduleName == 'CAPA' || this.qmsservice.moduleName == 'DV') {
          tname = "QMS_ALL_TASK_PERFORMERS_REP_VW";
          colList = "TASK_ID,DEPT_NAME,TASK_TYPE,SHORT_DESCRIPTION,REQUESTED_AT,CORE_BUSINESS_AREA_NAME,STATUS,STAGE_NAME,INITIATOR,OWNER,QA_ACCEPTOR,REVIEWRS,APPROVERS,CLOSURE_REVIEWRS,CLOSURE_APPROVERS";
          fieldList = this.qmsservice.moduleName + ` ID,Dept Name, ${this.qmsservice.moduleName} Type,Short Description,Requested At,Business Area,Status,Stage Name,Initiator,Owner,QA User,Reviewers,Approvers,Closure Reviewers,Closure Approvers`;
          data2 = {

            groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
            module: this.qmsservice.moduleName,
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: this.selectedStageValue ? this.selectedStageValue : null,
            status: this.selectedStatusValue ? this.selectedStatusValue : null,
            no: this.activityId,
            wherVal: this.whereValsForExcel,
            reModule: "qms1"
          }
        } else {
          tname = "QMS_ALL_TASK_PERFORMERS_REP_VW";
          colList = "TASK_ID,DEPT_NAME,TASK_TYPE,SHORT_DESCRIPTION,REQUESTED_AT,CORE_BUSINESS_AREA_NAME,STATUS,STAGE_NAME,INITIATOR,OWNER,QA_ACCEPTOR,INVESTIGATOR,REVIEWRS,APPROVERS,CLOSURE_REVIEWRS,CLOSURE_APPROVERS";
          fieldList = this.qmsservice.moduleName + ` ID,Dept Name, ${this.qmsservice.moduleName} Type,Short Description,Requested At,Business Area,Status,Stage Name,Initiator,Owner,QA User,Investigator,Reviewers,Approvers,Closure Reviewers,Closure Approvers`;
          data2 = {

            groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
            module: this.qmsservice.moduleName,
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: this.selectedStageValue ? this.selectedStageValue : null,
            status: this.selectedStatusValue ? this.selectedStatusValue : null,
            no: this.activityId,
            wherVal: this.whereValsForExcel,
            reModule: "qms1"
          }
        }

      } else if (this.qmsservice.reportFor == 'Pending Actions') {
        tname = "ONEQMS_PENDING_ACTIONS";
        colList = "TASK_REF_NO,TASK_NAME,CURRENT_STATUS,SUB_TASK_CURRENT_STATUS,TASK_OR_SUBTASK_PREVIOUS_STATUS,OTHER_DETAILS,TASK_OWNER_USER_NAME,REQUESTER_USER_NAME,OPERATION,ACTION_REQUESTED_ON,PENDING_WITH_USER_NAMES,PENDING_WITH_USERS_ROLE,COMMENTS,DUE_ON,IS_ENABLED,SUB_TASK_TYPE,SUB_TASK_NAME";
        fieldList = this.qmsservice.moduleName + "ID,Task Name,Current Status,Sub Task Current Status,Task Or Subtask Previous Status,Other Details,Task Owner User Name,Requester User Name,Operation,Action Requested On,Pending With User,Pending With Users Role,Comments,Due On,Is Enabled,Sub Task Type,Sub Task Name";
        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: this.whereValsForExcel,
          reModule: "qms1"
        }
        this.onlyDateColumn = "";
      } else if (this.qmsservice.reportFor == 'Activity Vs User') {
        tname = "ONEQMS_PENDING_TASKS_VW";
        colList = "TASK_REF_NO,TASK_NAME,STATUS,TASK_OWNER_USER_NAME,REQUESTER_USER_NAME,ACTION_REQUESTED_ON,PENDING_WITH_USER_NAMES,DUE_ON,SUB_TASK_NAME";
        fieldList = this.qmsservice.moduleName + "ID,Task Name,Status,Task Owner User Name,Requester User Name,Action Requested On,Pending With User,Due On,Sub Task Name";
        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: this.whereValsForExcel,
          reModule: "qms1"
        }
        this.onlyDateColumn = "";
      } else if (this.qmsservice.reportFor == 'Overdue') {
        tname = "QMS_ALL_TASKS_VW";
        colList = "TASKS.TASK_ID,TASKS.SHORT_DESCRIPTION,TASKS.DEPT_CODE,TASKS.REQUESTED_AT,TASKS.CORE_BUSINESS_AREA_NAME,TASKS.EXPCETED_CLOSURE_ON,TASKS.OWNER_FULLNAME,TASKS.QA_FULLNAME,TASKS.STARTED_ON,TASKS.COMPLETED_ON,TASKS.STATUS,TASKS.STAGE_NAME,TASKS.EFFECTIVENESS_CHECK_REQD";
        fieldList = `${this.qmsservice.moduleName} ID,${this.qmsservice.moduleName} Description,Dept Code,Requested At,Business Area,Expected Closure Date,Owner Fullname,QA User,Started On,Completed On,Status,Stage Name,Effectiveness Check Required`;
        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: this.whereValsForExcel,
          reModule: "qms1"
        }
        this.onlyDateColumn = "TASKS.EXPCETED_CLOSURE_ON";
      } else if (this.qmsservice.reportFor == 'Extension') {
        tname = "QMS_ALL_TASK_EXTENSIONS_INTERVAL_REP_VW";
        colList = " TASK_ID,EXTENSION_ID,CURRENT_DUE_DATE,EXTENSION_REQUIRED_TILL,JUSTIFICATION,STATUS,REVIEW_REQUESTED_ON,REVIEWER,REVIEWED_ON,REVIEW_COMMENTS,APPROVE_REQUESTED_ON,APPROVER,APPROVED_ON,APPROVER_COMMENTS,CREATED_BY_USER,EXTENSION_TYPE,ACTION_DETAILS";
        fieldList = `${this.qmsservice.moduleName} ID,Extension ID,Current Due Date,Extension Required Till,Justification,Status,Review Requested On,Reviewer,Reviewed On,Review Comments,Approve Requested On,Approver,Approved On,Approver Comments,Created By User,Extension Type,Action Details`;
        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: "",
          reModule: "qms"
        }
        this.onlyDateColumn = "EXTENSION_REQUIRED_TILL,CURRENT_DUE_DATE";
      } else if (this.qmsservice.reportFor == 'Effectiveness Check') {
        tname = "QMS_ALL_TASK_EC_INTERVALS_REP_VW";
        colList = "TASK_ID,EC_ID,DUE_DATE,METHODOLOGY,CRITERIA,CONCLUSION,OUTCOME,CLOSURE_COMMENTS,APPROVAL_REQUESTED_ON,APPROVAL_COMMENTS,APPROVED_ON,APPROVER,QA_APPROVAL_REQUESTED_ON,QA_APPROVED_ON,QA_APPROVER,QA_APPROVAL_COMMENTS,REMIND_N_DAYS_BEFORE_DUE_DATE,CREATED_BY_USER,TRIGGERED_FROM_EC_ID,CHECK_REQD_FOR,STATUS,OWNER_NAME,START_DATE";
        fieldList = `${this.qmsservice.moduleName} ID,EC ID,Due Date,Methodology,Criteria,Conclusion,Outcome,Closure Comments,Approval Requested On,Approval Comments,Approved On,Approver,QA Approval Requested On,QA Approved On,QA Approver,QA Approval Comments,Reminder Days Before Due Date,Created By User,Triggered From Execution Context ID,Check Required For,Status,Owner Name,Start Date`;

        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: "",
          reModule: "qms"
        }
      } else if (this.qmsservice.reportFor == 'Action') {
        tname = "QMS_ALL_TASK_ACTIONS_INTERVAL_REP_VW";
        colList = "TASK_ID,SL_NO,ACTION_ID,ACTION_NAME,ACTION_DESCRIPTION,STARTED_ON,STATUS,TARGET_DATE,ACTION_AT,CORE_BUSINESS_AREA,ASSIGNED_TO,ASSIGNED_TO_DEPARTMENT,COMMENTS,ACTION_PERFORMED,REVIEW_REQUESTED_ON,REVIEWER,REVIEW_STATUS,REVIEW_COMMENTS,REVIEW_COMPLETED_ON,APPROVAL_REQUESTED_ON,APPROVER,APPROVAL_STATUS,APPROVAL_COMMENTS,APPROVAL_COMPLETED_ON,DEFER_REVIEWER,DEFER_APPROVER,CREATED_ON,CREATED_BY_USER,INTERVALS";
        fieldList = `${this.qmsservice.moduleName} ID,SL NO,Action ID,Action Name,Action Description,Started On,Status,Target Date,Action At,Core Business Area,Assigned To,Assigned To Department,Comments,Action Performed,Review Requested On,Reviewer,Review Status,Review Comments,Review Completed On,Approval Requested On,Approver,Approval Status,Approval Comments,Approval Completed On,Defer Reviewer,Defer Approver,Created On,Created By User,Intervals`;
        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedActionDate ? this.selectedActionDate : null,
          fromDate: this.fromDate,
          toDate: this.toDate,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: "",
          reModule: "qms"
        }
        this.onlyDateColumn = "TARGET_DATE";
      } else if (this.qmsservice.reportFor == 'Deleted' || this.qmsservice.reportFor == 'Obsoleted') {
        tname = "QMS_ALL_TASKS_VW";
        colList = "TASK_ID,SHORT_DESCRIPTION,DEPT_CODE,REQUESTED_AT,CORE_BUSINESS_AREA_NAME,OWNER_FULLNAME,QA_FULLNAME,STARTED_ON,COMPLETED_ON,STATUS,STAGE_NAME,EFFECTIVENESS_CHECK_REQD";
        fieldList = `${this.qmsservice.moduleName} ID,${this.qmsservice.moduleName} Description,Department Code,Requested At,Business Area,Owner ,QA ,Started On,Completed On,Status,Stage Name,Effectiveness Check Required`;
        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: this.whereValsForExcel,
          reModule: "qms1"
        }
      } else if (this.qmsservice.reportFor == 'Milestone') {
        tname = "ONEQMS_TASK_MILESTONES_INTERVALS_REP_VW";
        colList = "TASK_ID,STATUS,TASK_TYPE,CREATED_ON,REVIEW_REQUESTED_ON,REVIEW_COMPLETED_ON,APPROVAL_REQUESTED_ON,APPROVAL_COMPLETED_ON,CLOSURE_REVIEW_REQUESTED_ON,CLOSURE_REVIEW_COMPLETED_ON,CLOSURE_APPROVAL_REQUESTED_ON,CLOSURE_APPROVAL_COMPLETED_ON,STARTED_ON,COMPLETED_ON,SIGNOFF_REQUESTED_ON,SIGNOFF_COMPLETED_ON";
        fieldList = `${this.qmsservice.moduleName}  ID, Status, ${this.qmsservice.moduleName}  Type, Created On, Review Requested On, Review Completed On, Approval Requested On, Approval Completed On, Closure Review Requested On, Closure Review Completed On, Closure Approval Requested On, Closure Approval Completed On, Started On, Completed On, Signoff Requested On, Signoff Completed On`;
        data2 = {

          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: this.qmsservice.moduleName,
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: this.whereValsForExcel,
          reModule: "qms"
        }
        this.onlyDateColumn = "CREATED_ON";
      }
      console.log(value, "--------------------");
      const data = {

        groupId: this.qmsservice.selectedGroup
      }
      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: this.statusCodeValue,
        codelistGroup: null,
        manualEntryDataFields: this.onlyDateColumn,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        footer: this.selectedReportFooter,
        logoId: this.selectedReportLogoValue ?? null,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? this.qmsservice.reportFor,
        currentStatus: "NA",
        groupName: this.qmsservice.activity.groupName + "",
      }
      if (this.qmsservice.reportFor == 'Product Report') {
        datas = {

          gridName: this.dynamicGridName,
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null
        }
        this.appService.getDynamicGridHeaders(datas).subscribe((response: any) => {

          response.orderByClause ??= "";
          data2 = {

            gridName: this.dynamicGridViewName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            selectedUserId: null,
            manualEntryDataFields: response.manualEntryDataFields,
            wherVal: this.whereValsForExcel,
            logoId: this.selectedReportLogoValue ?? 0,
            footer: this.selectedReportFooter,
            isSaveRep: this.isSaveReport ? 'Y' : 'N',
            reportName: this.reportName ?? "Report",
            currentStatus: "NA",
            groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
            groupName: "",
            chartStatus: null,

          }
          this.reportObj = { ...data, ...data2 };
          debugger;
          const timestamp = Date.now();
          const formattedDate = new Intl.DateTimeFormat('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          })
            .format(new Date(timestamp))
            .replaceAll(',', '')
            .replaceAll(' ', '_');

          let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
          const fileName = `${this.qmsservice.reportFor}_${formattedDate}.${fileType}`;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: "Report", columns: [],
              "informationTab": {
                "Report Name": this.qmsservice.reportFor + " Report",
                "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, fileName);
          } else {
            const pdfData = {
              ...this.reportObj, title: this.qmsservice.reportFor + " Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, fileName);
          }
        });


      } else {
        this.reportObj = { ...data1, ...data, ...data2 };
        debugger;
        const timestamp = Date.now();
        const formattedDate = new Intl.DateTimeFormat('en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
          .format(new Date(timestamp))
          .replaceAll(',', '')
          .replaceAll(' ', '_');

        let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
        const fileName = `${this.qmsservice.reportFor}_${formattedDate}.${fileType}`;
        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: "Report", columns: [],
            "informationTab": {
              "Report Name": this.qmsservice.reportFor + " Report",
              "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, fileName);
        } else {
          const pdfData = {
            ...this.reportObj, title: this.qmsservice.reportFor + " Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, fileName);
        }
      }

    }
  }


  openReportPopup(item: any) {

    if (this.qmsservice.reportFor == 'Product Report') {
      console.log("this.columnLists=", this.columnLists);
      this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => ({ valueExp: column.fieldColumnarray, displayExp: column.fieldColumnarray }));
      console.log("this.excelPdf.dropDown=", this.columnLists);
    } else {
      this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    }
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.pdfColumnSelection = false;
    this.isSaveReport = false;
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }
  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }


  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsservice.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

  //end excell & pdf
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  dropDownForChangeType: any = [];
  //more activity
  moreActivityReportDetails(value: any) {
    if (value == "Default") {
      this.resetFunction1();
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.resetFunction1();
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.refreshbreadcrumb = false;
      this.ngOnChanges();
      this.router.navigate(['/dashboard/MoreActivityReportDetailsComponent/', this.qmsservice.moduleName]);
      if (this.selectedGroupValue) {
        this.genReport();
      }
    }
  }
  auditFindingReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/AuditReportFindingDetailComponent/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  findingDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/findingDueDate/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  followupDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/followupDueDate/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  ngOnChanges() {
    console.log(this.refreshbreadcrumb)
    this.message.breadcrumbData.thirdLevel = 'Report';
    this.message.breadcrumbData.fourthLevel = this.qmsservice.reportFor;
    this.message.breadcrumbData.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;

    if (this.breadcrumbComponent) {
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      this.breadcrumbComponent.thirdLevel = 'Report';
      this.breadcrumbComponent.fourthLevel = this.qmsservice.reportFor;
    }
    this.refreshbreadcrumb = true;
    console.log(this.refreshbreadcrumb)
  }
  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onGroupValueSelect1st(item: any) {

    this.handleDropDownValidation('groupNameAlert', item);
  }
  onGroupValueSelect1(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedTaskTypeValue = null;
      this.appService.getQmsGroupDetailsByModule(item.valueExp, this.qmsservice.moduleName).subscribe((data: any) => {
        this.qmsservice.selectedGroupDetailData = data;
        this.appService.getTypeSettingsByGrpIdGrpDetailId(item.valueExp, data.groupDetailId).subscribe((response: any) => {
          this.dropDownForChangeType = response;
          this.selectBoxeForchangeType();
        })
      });
      this.handleDropDownValidation('dateRange2', this.selectedActionDate)
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedTaskTypeValue = null;
      this.appService.getQmsGroupDetailsByModule(item.valueExp, this.qmsservice.moduleName).subscribe((data: any) => {
        this.qmsservice.selectedGroupDetailData = data;
        this.appService.getTypeSettingsByGrpIdGrpDetailId(item.valueExp, data.groupDetailId).subscribe((response: any) => {
          this.dropDownForChangeType = response;
          this.selectBoxeForchangeType();
        })
      });
    }
  }
  onOverDueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedOverDue = item; // Assuming you are setting the selected value here
      this.handleDropDownValidation('overDue', this.selectedOverDue);
      const overDueField = document.getElementById('overDue') as HTMLInputElement;
      if (overDueField) {
        overDueField.style.color = '';
      }
    }
  }
  onExtensionSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedTaskTypeValue = null;
      this.appService.getQmsGroupDetailsByModule(this.selectedGroupValue ? this.selectedGroupValue : null, this.qmsservice.moduleName).subscribe((data: any) => {
        this.qmsservice.selectedGroupDetailData = data;
      });
      this.handleDropDownValidation('dateRange1', this.selectedExtensionDate)
    }
  }
  @ViewChild('pdf') pdf: MatSelect;
  pdfColumnSelection = false;
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfColumnSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  toggleAllSelection1(value: any) {
    if (value == 'pdf') {
      if (this.pdfColumnSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  onPDFSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.pdfColumnSelection = this.excelPdf.dropDown.length == this.selectedColumns.length;
        this.convertArrayToString(this.selectedColumns);
      })
    }
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const organizationReportImageDetail of this.organizationReportImageDetails) {

              console.log(
                "this.organizationReportImageDetails=",
                organizationReportImageDetail.reportImageId,
                this.imageIdList[i]
              );

              if (organizationReportImageDetail.reportImageId == this.imageIdList[i]) {

                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: organizationReportImageDetail.reportImageId,
                  displayExp: organizationReportImageDetail.reportImageName
                });

              }

            }
          }
        }
      } else {
        for (const organizationReportImageDetail of this.organizationReportImageDetails) {

          if (organizationReportImageDetail.reportImageId == this.dropDownDataForReportLogo.reportImageList) {

            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: organizationReportImageDetail.reportImageId,
              displayExp: organizationReportImageDetail.reportImageName
            });

          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const reportLogoDropdownVal of this.reportLogoDropdown) {

          if (reportLogoDropdownVal.valueExp == this.dropDownDataForReportLogo.defaultReportName) {

            this.selectedReportLogoValue = reportLogoDropdownVal.valueExp;

          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log("ngOnInit");
      this.refreshbreadcrumb = false;
      this.ngOnChanges();
      this.isProcessing = true;
      this.isProcessing = true;
      this.selectedGroupValue = this.qmsservice.SelectedGroupNameAndValue[0].valueExp;
      this.onGroupValueSelect1st({ valueExp: this.qmsservice.SelectedGroupNameAndValue[0].valueExp, displayExp: this.qmsservice.SelectedGroupNameAndValue[0].displayExp })
      console.log("data activity", this.qmsservice)
      if (this.selectedGroupValue) {
        this.genReport()
      }
      forkJoin([
        this.appService.getCodeListsByGroup('REPORT_DATE_EXTENSION_RANGE'), //For Extension
        this.appService.getCodeListsByGroup('REPORT_DATE_ACTION_RANGE'),  //For Action
        this.appService.getCodeListsByGroup('REPORT_DATE_UPDATE_RANGE'), // For EffectiveNess
        this.appService.getCodeListsByGroup('REPORT_DATE_RANGE'),
        this.appService.getCodeListsByGroup('REPORT_INTERVAL'),
        this.appService.getCodeListsByGroup('REB_DUE_DROPDOWN_VAL'),
        this.appService.getQmsReportUsers(this.qmsservice.moduleName),
        this.appService.getQmsAllTasksVw(this.qmsservice.moduleName),
        this.appService.getStagesAndStatus(this.qmsservice.moduleName),
      ]).subscribe(([extensionDateRange, actionDateRange, updateDateRangeData, typdropDownForDateRangeData, typdropDownForIntervalData, overDueData, groupdataList, allTasksList, stageAndStatus]) => {
        this.dropDownForUpdateDate = updateDateRangeData;
        this.selectBoxForUpdateDate()
        this.dropDownForActionDate = actionDateRange;
        this.selectBoxForActionDate()
        this.dropDownForExtensionDate = extensionDateRange;
        this.selectBoxForExtensionDate()
        console.log("stageAndStatus=", stageAndStatus)
        this.dropDownForDateRange = typdropDownForDateRangeData;
        this.selectBoxForDateRange();
        this.dropDownForInterval = typdropDownForIntervalData;
        this.selectBoxForInterval();
        this.dropDownForOverDue = overDueData;
        this.selectBoxForOverDue();
        this.groupdataList = groupdataList;
        this.selectBoxeForGroupValue();
        this.allTasksList = allTasksList;
        this.stageAndStatus = stageAndStatus;
        this.selectBoxeForStageValue();
        if (this.selectedGroupValue) {
          this.appService.getQmsGroupDetailsByModule(this.selectedGroupValue ? this.selectedGroupValue : null, this.qmsservice.moduleName).subscribe((data: any) => {
            this.qmsservice.selectedGroupDetailData = data;
            this.appService.getTypeSettingsByGrpIdGrpDetailId(this.selectedGroupValue ? this.selectedGroupValue : null, data.groupDetailId).subscribe((response: any) => {
              this.dropDownForChangeType = response;
              this.selectBoxeForchangeType();
            })
          });
          this.genReport();
        }
        this.isProcessing = false;
      })
      this.appService.getCodeListsByGroup("DESIGNATION").subscribe((response: any) => {
        this.dropDownForDesignationCode = response;
        this.selectBoxeForDesignationCode();
      })
      this.appService.getCodeListsByGroup("DEPARTMENT").subscribe((response: any) => {
        this.dropDownForDepartmentCode = response;
        this.selectBoxeForDepartmentCode();
      })
    });

    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.selectedGroupValue).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();
  }
  snackbarRef: any;
  searchText: any;
  _temp: any = {};
  visibleDataGrid: boolean = false;
  tableReportExpireCheckList: any = [];
  filteredGridData: any = [];
  visibleAddButton: boolean;
  visibleEditButton: boolean;
  selectedFolderPath: any;
  selectedDocumentTypeName: any;
  selectedDocContainer: any;
  tmsUserTrainingsRepVwDataForGrid: any = [];
  dynamicGridName: any;
  dynamicGridViewName: any;
  private readonly searchSubject = new Subject<{
    column: string,
    filterValue: string,
    val: any
  }>();

  getcallMethodProduct() {
    this.isProcessing = true;
    this.showTables = true;
    if (!this.selectedGroupValue) {
      const field = document.getElementById('groupNameAlert') as HTMLInputElement;
      field.style.color = 'red';
    }

    this.dynamicGridName = "QMS_CCP_CC_GRID";
    this.dynamicGridViewName = "QMS_CCP_CC_GRID_VW";
    const data = {

      gridName: "QMS_CCP_CC_GRID",
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        let data1: any;
        this.columnList = response.columnsList;
        data1 = {

          gridName: "QMS_CCP_CC_GRID",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: null,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
          module: this.qmsservice.moduleName,
          stageName: this.selectedStageValue ? this.selectedStageValue : null,
          status: this.selectedStatusValue ? this.selectedStatusValue : null,
          wherVal: this.oneQmsUsersFieldData.managerId ? this.oneQmsUsersFieldData.managerId : null,
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            this.filteredGridData = response1;

            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.setPage(1, 0);
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || (this.pager.totalPages && page > this.pager.totalPages)) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.filteredGridData.length, page, this.perPage, targetpage);
    if (this.filteredGridData.length > 0) {
      this.pagedItems = this.filteredGridData
        .slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  applyFilter7(column: string, event: Event, val: any): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.searchSubject.next({ column, filterValue, val });
  }
  //dynamic grid
  //  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData1(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName,
    }
    let clobApi: any;
    clobApi = this.appService.getClobToViewDistributed(docObj);
    this.htmlContent = "";
    clobApi.subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    })
    this.isProcessing = false;
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  //setting reorder start
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.dynamicGridName, this.dynamicGridViewName, null, 0);
  }
  onChildValueEmitted() {
    console.log("refresh");
    this.genReport();
  };

}


